export default __webpack_public_path__ + "e4b250af1625c2a25fbc8821dfbbfb36.svg";